var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0193 16.1923C12.2557 16.1927 12.4899 16.1464 12.7084 16.056C12.9269 15.9657 13.1254 15.8331 13.2925 15.6658L15.6439 13.3142L14.7955 12.4688L12.6157 14.6477L12.6001 4.80005H11.4001L11.4157 14.6381L9.24366 12.4676L8.39526 13.3142L10.7467 15.664C10.9135 15.8315 11.1118 15.9644 11.3302 16.055C11.5486 16.1457 11.7828 16.1923 12.0193 16.1923Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 14.3933V17.3913C18 17.5503 17.9368 17.7028 17.8243 17.8152C17.7118 17.9277 17.5592 17.9908 17.4 17.9908H6.60005C6.44092 17.9908 6.28831 17.9277 6.17578 17.8152C6.06326 17.7028 6.00005 17.5503 6.00005 17.3913V14.3933H4.80005V17.3913C4.80005 17.8683 4.98969 18.3258 5.32726 18.6632C5.66482 19.0005 6.12266 19.19 6.60005 19.19H17.4C17.8774 19.19 18.3353 19.0005 18.6728 18.6632C19.0104 18.3258 19.2 17.8683 19.2 17.3913V14.3933H18Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.67a837f0d2b9f2ee324f761ec3ffacec.svg";
export { ForwardRef as ReactComponent };